import React, { useEffect, useState } from 'react'
import { TextGray } from '../../pages/Theme';
import { staticFiles } from '../Helpers/Static';
import { Card, TextBlack } from '../../pages/Theme';
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import axios from 'axios';
import { serverUrl } from '../Helpers/Config';
import noprofile from "../../common/images-new/no-profile-pic.png";
import { tokenAuthorize } from '../Helpers/Common';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { FaRegCommentDots } from "react-icons/fa";
import { CommonLoader } from '../Button/Loader';
const LoveRed = staticFiles.loveRed;
const LoveGray = staticFiles.loveGray;
const ChatBlackIcon = staticFiles.chat;

const LikeComment = ({ currentIsLiked, readOnly = false, numLikes, numComments, handleComment, handleLike, likesList, isShowcase, reflection_id, isPinned }) => {
    const [show, setShow] = useState(false);
    const [likeList, setlikeList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [like, setLike] = useState(isLiked)
    // const [numOfLikes, setNumOfLikes] = useState(numLikes)

    // const handleLike = () => {
    //     setLike(!like)
    //     if (!like === true){
    //         setNumOfLikes(numLikes + 1)
    //     }
    //     else {
    //         setNumOfLikes(numLikes)
    //     }
    // }
    useEffect(() => {
        if (likeList !== undefined) {
            setlikeList(likesList);
        }
    }, [show, numLikes])

    const showMembers = (e) => {
        e.stopPropagation();
        setIsLoading(true);
        if (isShowcase) {
            axios.get(serverUrl.GetLikesMembers + `/${reflection_id}`).then(res => {
                let list = res.data.results;
                setlikeList(list);
                setIsLoading(false);
                setShow(!show); 
            })
                .catch(err => {
                    tokenAuthorize(err?.response?.status);
                    console.log(err)
                })

        }
        else {
            setIsLoading(false);
            setShow(!show);
        }
        setShow(!show);
    }


    const Members = () => {
        let style = show ? "flex" : "hidden";
        style += " fixed inset-0 modelIndex items-center justify-center bg-black bg-opacity-50 px-4 py-6";
        return (
            <div className={style}>
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
                    <div className="flex gap-2 items-center justify-between">
                        <p className="font-semibold blackColor">Likes</p>
                        <button
                            onClick={showMembers}
                            className="text-gray-600 hover:text-black text-xl font-bold"
                        >&times;
                        </button>
                    </div>
                    <div>
                        {isLoading ? <div className='w-full flex items-center justify-center'>
                            <CommonLoader/>
                        </div> :
                        // `${isPinned ? "overflow-y-auto max-h-72" : "overflow-y-auto h-4/6 pb-2"}
                            <div className={`overflow-y-aut0 max-h-72`}>
                                {likeList && likeList.map((likeItem, index) => (
                                    <div key={index} className="flex my-3 gap-2 items-center" >
                                        <Link to={"/profile/" + likeItem.guid} target="_blank">
                                            <img src={likeItem.photo ? likeItem.photo : noprofile} className="rounded-full w-9 h-9" />
                                        </Link>
                                        <Link to={"/profile/" + likeItem.guid} target="_blank" className="font-semibold blackColor text-base hover:opacity-80 hover:no-underline">
                                            <p className='blackColor'>{likeItem.fullname}</p>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
                {/* {isLoading ?
                    <Card className="flex justify-center items-center w-72 md:w-80 lg:w-1/3 h-2/4 rounded-lg overflow-hidden">
                        <div className='w-full flex items-center justify-center'>
                            <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
                        </div>
                    </Card> :
                    <Card className={isPinned ? "w-72 md:w-80 lg:w-3/5 h-3/5 rounded-lg overflow-hidden" : " w-72 md:w-80 lg:w-1/3 h-3/5 rounded-lg overflow-hidden"}>

                        <>
                            <div className="relative flex py-6">
                                <div className="w-full font-bold flex justify-center items-center">
                                    Likes
                                </div>
                                <div className="absolute right-5 top-5" onClick={showMembers}>
                                    <AiOutlineClose className="w-7 h-7 opacity-30 cursor-pointer hover:opacity-100" />
                                </div>
                            </div>
                            <hr />
                            <div className={isPinned ? "overflow-y-auto h-4/6 pb-2" : "overflow-y-auto h-4/6 pb-2"} style={{ height: isPinned ? "73%" : "73%" }}>
                                {likeList && likeList.map((likeItem, index) => (
                                    <div key={index} className="flex ml-5 mt-4 items-center" >
                                        <Link
                                            to={"/profile/" + likeItem.guid}
                                            target="_blank"
                                        >
                                            <img src={likeItem.photo ? likeItem.photo : noprofile} className="rounded-full w-9 h-9" />
                                        </Link>
                                        <Link
                                            to={"/profile/" + likeItem.guid}
                                            target="_blank"
                                            className="ml-4 font-semibold text-lg hover:opacity-80 hover:no-underline"
                                        >
                                            <TextBlack>
                                                {likeItem.fullname}
                                            </TextBlack>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </>
                    </Card>
                } */}
            </div>

        );

    };

    return (
        <>
            {numLikes > 0 && <Members />}
            <div className="flex flex-row gap-3">
                <div className="flex items-center gap-0.5">
                    {parseInt(currentIsLiked) ?
                        <ThumbUpAltIcon fontSize="small" className={`likeIcon primaryIcon ${readOnly ? "pointer-eventNone" : "cursor-pointer"}`} onClick={handleLike} />
                        :
                        <ThumbUpOffAltIcon fontSize="small" className={`likeIcon secondaryIcon ${readOnly ? "pointer-eventNone" : "cursor-pointer"}`} onClick={handleLike} />
                    }
                    <span className={`lightColor ${numLikes < 1 ? "pointer-eventNone" : "cursor-pointer"}`} onClick={showMembers}>{numLikes} Likes</span>
                </div>
                <div className={`flex items-center gap-1 ${readOnly ? "pointer-eventNone" : "cursor-pointer"} `} onClick={handleComment}>
                    <FaRegCommentDots className={`w-4 h-4 secondaryIcon`} />
                    <span className="lightColor">{numComments} Comments</span>
                </div>
            </div>
        </>
    )
}

export default LikeComment